export const namespacedPrefix = '[INGREDIENTS]';
